export const SET_PLAYER_SHORT_INFO = "SET_PLAYER_SHORT_INFO";
export const SET_TEAM_FOR_TRANSFERS = "SET_TEAM_FOR_TRANSFERS";
export const SET_AVAILABLE_PLAYERS_FOR_TRANSFER = "SET_AVAILABLE_PLAYERS_FOR_TRANSFER";
export const RESTORE_AVAILABLE_PLAYER_FOR_TRANSFER = "RESTORE_AVAILABLE_PLAYER_FOR_TRANSFER";
export const REMOVE_AVAILABLE_PLAYER_FOR_TRANSFER = "REMOVE_AVAILABLE_PLAYER_FOR_TRANSFER";
